// Copyright © 2022 Olo Inc. All rights reserved.
// This software is made available under the Olo Pay SDK License (See LICENSE.md file)
import { registerPlugin } from '@capacitor/core';
import sdkInfo from "./sdkInfo.json";
const OloPaySDK = registerPlugin('OloPaySDK', {
    web: () => import('./web').then(m => new m.OloPaySDKWeb()),
});
OloPaySDK.initializeInternal({ version: sdkInfo.version, buildType: sdkInfo.buildType });
export * from './definitions';
export { OloPaySDK };
//# sourceMappingURL=index.js.map